module.exports = __webpack_public_path__ + "media/bootstrap-icons/basket-fill-ff44cdb6.svg";